import { __makeTemplateObject } from "tslib";
import { fakeBorder, styled } from '../../../../foundation';
import { RcPopover } from '../../../Popover';
import { RcDatePickerClasses } from '../DatePicker/utils';
import { RcTimePickerClasses } from '../TimePicker/utils';
export var StyledPopover = styled(RcPopover)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .", ", .", " {\n    ", ";\n  }\n"], ["\n  .", ", .", " {\n    ", ";\n  }\n"])), RcDatePickerClasses.popoverPaper, RcTimePickerClasses.popoverPaper, fakeBorder({ pseudo: true, radius: 'lg' }));
var templateObject_1;
